/*export const config = {
    api_url: "http://localhost:9500",
    pict_url: "http://localhost:9500/images/"
};*/

export const config = {
	api_url: "https://beer4youapi.manuellamaya.com",
	pict_url: "https://beer4youapi.manuellamaya.com/images/"
};